// @keep_environment_variables_in_sync
const ENVIRONMENTS = [
  // production environments
  { domain: /^eu.ps.nulogy.net/, enableSentry: true, name: "eu_production" },
  { domain: /^ps.nulogy.net/, enableSentry: true, name: "na_production" },
  { domain: /^training.ps.nulogy.net/, enableSentry: true, name: "training" },

  // test environments
  { domain: /^test.qa-ps.nulogy.net/, enableSentry: true, name: "test" },

  // development
  { domain: /./, enableSentry: false, name: "development" },
];

export default {
  enableSentry,
  environmentName,
};

function enableSentry() {
  return _environment().enableSentry;
}

function environmentName() {
  return _environment().name;
}

function _environment() {
  const domainName = _extractDomainName(window.location.href);

  return ENVIRONMENTS.find((e) => domainName.match(e.domain));
}

function _extractDomainName(url) {
  const a = document.createElement("a");
  a.href = url;

  return a.hostname;
}
